import React, { useEffect } from 'react';

function ITTech() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" role="main">
      {/* Hero Section */}
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">
                IT & Technology <span className="hero__highlight">Recruiting Berlin</span>
              </h1>
              <p className="hero__subtitle">
                Tech-Talente in Berlin finden: Entwickler, Designer, Product Manager
                über Social Media. Maßgeschneiderte Strategien für die IT-Branche seit 2009.
              </p>
              <div className="hero__cta">
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA">
                  Kostenloses Erstgespräch
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">IT & Technology Recruiting: Die Zukunft der Tech-Talente in Berlin</h2>
            <p className="section-subtitle">
              Berlin ist das Tech-Zentrum Europas. Bei famefact spezialisieren wir uns
              auf IT-Recruiting über Social Media – von Entwicklern bis zu Product
              Managern, wir finden die besten Talente für Ihre Tech-Projekte.
            </p>
          </div>

          <div className="content-grid">
            <div className="content-text">
              <h3>Warum IT-Recruiting in Berlin über Social Media erfolgreich ist</h3>
              <p>
                Die IT-Branche in Berlin wächst rasant und hat sich in den letzten Jahren zur Tech-Hauptstadt Europas entwickelt. Mit über 1.000 Tech-Unternehmen, darunter Unicorns wie N26, Zalando und HelloFresh, sowie unzähligen Start-ups in Kreuzberg, Prenzlauer Berg und Mitte, ist der Wettbewerb um qualifizierte IT-Talente intensiver denn je. Der Fachkräftemangel in der Tech-Branche ist real: Laut Bitkom bleiben jährlich über 96.000 IT-Stellen in Deutschland unbesetzt – ein Großteil davon in Berlin.
              </p>
              <p>
                Social Media hat sich als revolutionärer Kanal für IT-Recruiting etabliert, da Tech-Talente dort aktiv sind, wo sie sich informieren, vernetzen und inspirieren lassen. Während traditionelle Jobbörsen zunehmend an Relevanz verlieren, nutzen IT-Professionals LinkedIn für berufliche Vernetzung, GitHub für Code-Sharing, Twitter/X für Tech-Diskussionen und Instagram für Einblicke in Unternehmenskulturen. Genau hier setzen wir an.
              </p>
              <p>
                Unsere IT-Recruiting Strategie basiert auf drei Säulen: <strong>Authentische Tech-Community-Präsenz, datengetriebenes Targeting und Content, der IT-Professionals wirklich anspricht.</strong> Wir verstehen die Tech-Sprache, kennen die relevanten Frameworks und Tools und wissen, welche Arbeitsbedingungen für Entwickler, Designer und Product Manager entscheidend sind.
              </p>

              <div className="stats-grid">
                <div className="stat-box">
                  <span className="stat-box__number">8-25€</span>
                  <span className="stat-box__label">Pro Bewerbung</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">96.000+</span>
                  <span className="stat-box__label">Offene IT-Stellen</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">1.000+</span>
                  <span className="stat-box__label">Tech-Unternehmen Berlin</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">15+</span>
                  <span className="stat-box__label">Jahre Erfahrung</span>
                </div>
              </div>

              <h3>Die Berliner Tech-Landschaft: Herausforderungen und Chancen</h3>
              <p>
                Berlin ist einzigartig in der deutschen Tech-Landschaft. Die Stadt zieht internationale Talente an, hat eine lebendige Open-Source-Community und bietet eine Startup-Kultur, die Innovation fördert. Gleichzeitig bedeutet dies intensive Konkurrenz: Tech-Giganten wie Google, Amazon und Microsoft konkurrieren mit Unicorns und vielversprechenden Start-ups um dieselben Talente.
              </p>

              <h3>Unsere IT & Technology Recruiting Services</h3>
              
              <h4>1. Entwickler und Software Engineers</h4>
              <p>
                Entwickler sind das Rückgrat jedes Tech-Unternehmens. Wir verstehen, dass ein React-Entwickler nicht einfach ein React-Entwickler ist – es geht um Erfahrung mit spezifischen State-Management-Libraries, Testing-Frameworks und architektonischen Patterns.
              </p>
              <ul>
                <li><strong>Frontend Entwickler:</strong> React, Vue, Angular, Svelte</li>
                <li><strong>Backend Entwickler:</strong> Node.js, Python, Java, Go, Rust</li>
                <li><strong>Full-Stack Entwickler:</strong> Next.js, Nuxt, Django</li>
                <li><strong>DevOps Engineers:</strong> Kubernetes, Docker, CI/CD</li>
                <li><strong>Cloud Engineers:</strong> AWS, Google Cloud, Azure</li>
                <li><strong>Mobile Entwickler:</strong> Swift, Kotlin, React Native, Flutter</li>
                <li><strong>AI/ML Engineers:</strong> TensorFlow, PyTorch, Data Science</li>
              </ul>

              <h4>2. Designer und UX/UI Specialists</h4>
              <p>
                Designer schaffen die Schnittstelle zwischen Technologie und Nutzer. Wir verstehen, dass gutes Design mehr ist als Ästhetik: Es geht um User Experience, Accessibility, Design Systems und datengetriebene Entscheidungen.
              </p>
              <ul>
                <li><strong>UX/UI Designer:</strong> Figma, Sketch, Adobe XD</li>
                <li><strong>Product Designer:</strong> End-to-End Produktdesign</li>
                <li><strong>Visual Designer:</strong> Brand Identity, Illustration</li>
                <li><strong>Motion Designer:</strong> Animation, Micro-Interactions</li>
              </ul>

              <h4>3. Product Manager und Tech Leads</h4>
              <p>
                Product Manager und Tech Leads sind die Brücke zwischen Business, Design und Engineering. Sie treiben Produktvisionen voran, priorisieren Features und führen Teams zum Erfolg.
              </p>
              <ul>
                <li><strong>Product Manager:</strong> Strategy, Roadmap Planning</li>
                <li><strong>Technical Product Manager:</strong> Deep Technical Understanding</li>
                <li><strong>Tech Leads:</strong> Technical Leadership, Mentoring</li>
                <li><strong>Engineering Manager:</strong> Team Building, Performance Management</li>
              </ul>

              <h3>Social Media Strategien für IT-Recruiting</h3>
              
              <h4>LinkedIn: Das professionelle Netzwerk für IT-Talente</h4>
              <p>
                LinkedIn ist die wichtigste Plattform für IT-Recruiting, besonders für Senior Positionen. Wir nutzen LinkedIn Recruiter für gezielte Suchen und erstellen organischen Content, der Ihre Tech-Expertise demonstriert.
              </p>
              
              <h4>GitHub: Der Code spricht für sich</h4>
              <p>
                GitHub ist mehr als eine Code-Hosting-Plattform – es ist ein soziales Netzwerk für Entwickler. Wir analysieren Open-Source-Contributions und sprechen Entwickler an, deren Coding-Style zu Ihrem Unternehmen passt.
              </p>
              
              <h4>Instagram: Tech-Kultur visuell erlebbar machen</h4>
              <p>
                Instagram eignet sich hervorragend, um jüngere Tech-Talente und Designer anzusprechen. Wir kreieren Behind-the-Scenes-Content aus Ihrem Entwickler-Alltag.
              </p>

              <h3>Erfolgsfaktoren für IT-Recruiting in Berlin</h3>
              <ul>
                <li><strong>Tech-Communities:</strong> Aktive Beteiligung in Entwickler-Gruppen</li>
                <li><strong>Skills-Fokus:</strong> Präzise Ansprache nach Programmiersprachen</li>
                <li><strong>Remote-Optionen:</strong> Flexible Arbeitsmodelle anbieten</li>
                <li><strong>Portfolio-Review:</strong> Bewertung von GitHub und Projekten</li>
                <li><strong>Tech-Events:</strong> Präsenz bei Meetups und Konferenzen</li>
              </ul>

              <div className="cta-box">
                <h3>Kostenlose IT-Recruiting Analyse</h3>
                <p>Vereinbaren Sie Ihre kostenlose Analyse für IT-Recruiting.</p>
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Content CTA">
                  Kostenloses Erstgespräch
                </button>
              </div>
            </div>

            <div className="content-sidebar">
              <div className="sidebar-widget">
                <h3>IT-Positionen</h3>
                <ul>
                  <li>✓ Software Entwickler</li>
                  <li>✓ UX/UI Designer</li>
                  <li>✓ Product Manager</li>
                  <li>✓ DevOps Engineers</li>
                  <li>✓ AI Specialists</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Referenzen</h3>
                <p>Vertraut von:</p>
                <ul>
                  <li>Vattenfall</li>
                  <li>REWE</li>
                  <li>Casio</li>
                  <li>AutoHero</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Kontakt</h3>
                <p>
                  famefact Social Recruiting Berlin<br />
                  Schliemannstraße 23<br />
                  10437 Berlin<br />
                  <a href="tel:+4930403665430">030 403 665 430</a><br />
                  <a href="mailto:info@famefact.com">info@famefact.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ITTech;
